/*
The spinner, wrapping react-loader-spinner 6.

v3 had a single default export driven by a string: `<Loader type="TailSpin" ... />`. v6
replaced that with one named export per spinner and no `type` prop at all, so every call
site would otherwise have had to pick its own import and change its JSX. This keeps the v3
shape - `type`, `color`, `height`, `width` - and does the lookup here.

An unknown `type` falls back to TailSpin rather than rendering nothing, because the failure
mode this replaces is a spinner silently disappearing from a toolbar during a long export,
which reads as the export having hung.
*/
import React from 'react';
import PropTypes from 'prop-types';
import { TailSpin, Oval, ThreeDots } from 'react-loader-spinner';

const SPINNERS = {
  TailSpin,
  Oval,
  ThreeDots,
};

const Loader = ({
  type, color, height, width,
}) => {
  const Spinner = SPINNERS[type] || TailSpin;
  return <Spinner color={color} height={height} width={width} ariaLabel="loading" />;
};

Loader.propTypes = {
  // One of the keys of SPINNERS above. Anything else falls back to TailSpin.
  type: PropTypes.string,
  color: PropTypes.string,
  // v3 call sites pass both numbers and strings; v6 accepts either.
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Loader.defaultProps = {
  type: 'TailSpin',
  color: '#717171',
  height: 30,
  width: 30,
};

export default Loader;
